import React from 'react';
import Logo_home_out from "../../../Resources/Images/Nav/image_icons_header_homeout.webp";
import Logo_home_in from "../../../Resources/Images/Nav/image_icons_header_homein.webp";
import Logo_mobile from "../../../Resources/Images/Nav/image_icons_header_homeout_mobile.webp";
import "./LogoNav.css";
const LogoNav = ({type_logo}) =>{
    return(        
        <>
            <img width={393} height={33}  className='Logo d-none d-md-block mx-auto' src={type_logo === 2 ? Logo_home_out: Logo_home_in} alt="Logo Banistmo - BNP Paribas Cardif"></img>
            <img width={532} height={46}  className='Logo d-block d-md-none mx-auto' src={Logo_mobile} alt="Logo Banistmo - BNP Paribas Cardif"></img>        
        </>
    );
};

export default LogoNav;